<div>
  <div class="font-weight-bold mb-2 pb-1 pt-2 border-bottom">Are you sure you want to remove <span class="font-italic">{{medallionSize.title}}</span>?</div>
  <a href="javascript:void(0)" (click)="deleteMedallion()">Delete</a> | <a routerLink="/admin/medallions">Back</a>
</div>
